import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const quoteAcceptAtom = createMutationAtomFactory(
  'brokerage.quoteAccept',
  (params: { id: string }) => ({
    tradeQuoteAccept: {
      __args: {
        id: params.id,
      },
      id: true,
      status: true,
      timestamps: {
        updatedAt: true,
      },
    },
  }),
);
